function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Filter from './filter';
import Collection from './collection';
import Response from './response';
import URI from 'urijs'; // private

var filter = new Filter({
  order: 'submitted_at',
  direction: 'DESC'
});

var responseHistoryUrl = function responseHistoryUrl(participant) {
  /*
   * use a closure trick to pass
   * the participant to an anonymous
   * function that can be called later
   * without the participant object
   */
  // support both a participant instance or an id
  var id = participant.id || participant;
  return function () {
    return URI('/api/participants').segment(id.toString()).segment('responses').toString();
  };
};

var Responses = /*#__PURE__*/function (_Collection) {
  _inheritsLoose(Responses, _Collection);

  function Responses() {
    return _Collection.apply(this, arguments) || this;
  }

  var _proto = Responses.prototype;

  _proto.initialize = function initialize(options) {
    if (options == null) {
      options = {};
    }

    if (options.participant != null) {
      this.url = responseHistoryUrl(options.participant);
    }
  } // this is overridden by initialize
  ;

  _proto.url = function url() {
    return '/api/participants/-1/responses';
  };

  _proto.params = function params(obj) {
    if (obj != null) {
      return filter.set(obj);
    } else {
      return filter.attributes;
    }
  };

  _proto.query = function query() {
    return this.fetch({
      data: this.params(),
      reset: true
    });
  };

  _createClass(Responses, [{
    key: "model",
    get: function get() {
      return Response;
    }
  }]);

  return Responses;
}(Collection);

export { Responses as default };